import './dialog';

(function($) {
    $.widget("ca.caConfirm", $.ca.caDialog, {
        options: {
            showCloseButton: true,
            autoOpen: false,
            resizable: false,
            title: 'Confirm'
        },

        open: function() {         
            $.ui.dialog.prototype.open.apply(this, arguments);
            if (!this.options.showCloseButton) {
                this.element.parents('.ui-dialog').find('.block-options').remove();
            }
        },

        destroy: function() {
            $.ui.dialog.prototype.destroy.apply(this, arguments);
        }
    });

    /**
     * @param {string} message - a text of a confirmation dialog
     * @param {string} title - the title of a dialog
     * @param {string} confirm - a text of a confirm button
     * @param {string} cancel - a text of a cancel button
     * @param {function} onConfirm - the function to call when a confirm button is clicked
     * @param {function} onCancel - the function to call when a cancel button is clicked
     * @param {object} options - a map of option-value pairs to set
     * @param {string} goBackBtn - this is an extra button - the popup will show three buttons
     *
     */
    $.caConfirm = function(message, title, confirm, cancel, onConfirm, onCancel, options, goBackBtn) {
        $('.ca-confirm').remove();
        var dialog = $('<div id="confirm-dialog" class="form-horizontal form-bordered ca-confirm"></div>')
            .appendTo('body');

        var goBackbtnContent = '';
        if (goBackBtn != undefined) {
            goBackbtnContent = '<div class="pull-left">' +
                '<span class="ca-pro-ui">' +
                '<button name="cf-goback-button" id="cf-goback-button" type="button" ' +
                'class="btn btn-warning btn-sm"><i class="fa fa-ban"> </i> <span>No, go back</span>' +
                '</button>' +
                '</span> ' +
                '</div> ';
        }

        dialog.append(
            '<div class="form-group">' +
                '<div class="col-md-12 ca-pro-ui">' +
                    '<div class="ca-confirmation-label">' + message + '</div>' +
                '</div>' +
            '</div>' +
            '<div class="form-group form-actions">' +
                '<div class="col-md-12">' + goBackbtnContent +
                    '<div class="pull-right">' +
                        '<span class="ca-pro-ui">' +
                            '<button name="cf-cancel-button" id="cf-cancel-button" type="button" ' +
                            'class="btn btn-warning btn-sm"><i class="fa fa-ban"> </i> <span>No, go back</span>' +
                            '</button>' +
                        '</span> ' +
                        '<span class="ca-pro-ui">' +
                            '<button name="cf-confirm-button" id="cf-confirm-button" type="button" ' +
                            'class="btn btn-primary btn-sm"><i class="fa fa-check"> </i> <span>Yes, I am sure</span>' +
                            '</button>' +
                        '</span>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );

        message = message || 'Are you sure ?';

        $("#confirm-dialog").caConfirm();

        if (title != undefined) {
            $('#confirm-dialog').caConfirm('option', 'title', title);
            $('#confirm-dialog').parents('.ui-dialog').find('.block-title h2').html(title);
        }

        if (options instanceof Object) {
            $('#confirm-dialog').caConfirm('option', options);
        }         
        if (cancel != undefined) {
            $('#confirm-dialog #cf-cancel-button span').text(cancel);
        }

        if (confirm != undefined) {
            $('#confirm-dialog #cf-confirm-button span').text(confirm);
        }

        if (goBackBtn != undefined) {
            $('#confirm-dialog #cf-goback-button span').text(goBackBtn);
            $('#confirm-dialog #cf-cancel-button').css("color", "#1593b3");
            $('#confirm-dialog #cf-cancel-button').css("background-color", "#fff");
            $('#confirm-dialog #cf-cancel-button').css("border-color", "#1593b3");
            $('#confirm-dialog #cf-cancel-button .fa-ban').css('display','none');

        }

        $(".form-group.form-actions button").on('click', function() { $('.ca-confirm').remove(); } );

        if (onConfirm != undefined && typeof(onConfirm) == "function") {
            $("#cf-confirm-button").on('click', onConfirm);
        }

        if (onCancel != undefined && typeof(onCancel) == "function") {
            $("#cf-cancel-button").on('click', onCancel);
        }
        $('#confirm-dialog').caConfirm('open', message);
    };
})(jQuery);
